export const parseHolidayDays = (value: string, maximumDay = 31) =>
  Array.from(
    new Set(
      value
        .split(",")
        .map((day) => Number(day.trim()))
        .filter((day) => Number.isInteger(day) && day >= 1 && day <= maximumDay)
    )
  ).sort((first, second) => first - second);
